export default __webpack_public_path__ + "images/be3fd0917bcb9633605ae1b3ff5dc121-knitting.webp";